<div class="header-left">
  <mat-checkbox
    color="primary"
    class="invite-all-checkbox"
    *ngIf="!jobInPast"
    (change)="onCheckboxClick($event)"
    data-cy="select-all-checkbox">
  </mat-checkbox>
  <div>
    <span>{{ ("name" | i18n) || "name" | titlecase }}</span>
    <span *ngIf="multiDay">
      {{ ("available" | i18n) || "verfügbar" | titlecase }}
    </span>
  </div>
</div>
<div class="header-right">
  <ng-container *ngIf="suggestInsteadDirectAccept">
    {{ ("suggestDirectly" | i18n) || "sofort einreichen" }}
  </ng-container>
  <ng-container *ngIf="!suggestInsteadDirectAccept">
    {{ ("bookDirectly" | i18n) || "sofort buchen" }}
  </ng-container>

  <div *ngIf="isLoading">
    <mat-spinner
      diameter="24"
      data-cy="possible-users-spinner"></mat-spinner>
  </div>
</div>
